import ApiService from "../ApiService";
import { toRUDate } from '@/utilities';


class TimeSlot {
  constructor(data) {
    this.id = data.id;
    this.date = toRUDate(new Date(data.date));
    this.start_datetime = new Date(data.date + "T" + data.start_time);
    this.end_datetime = new Date(data.date + "T" + data.end_time);
    this.interval = data.interval;
    this.capacity = data.capacity;
    this.overlaps = data.overlaps;
    this.created = data.created;
    this.isOpen = data.is_open;
    this.source = data.source;
    this.notary = data.notary; //new Notary(data.notary);
  }

  toString() {
    let startMinutes = this.start_datetime.getMinutes();
    if (startMinutes < 10) {
      startMinutes = `0${startMinutes}`
    }
    const starTime = `${this.start_datetime.getHours()}:${startMinutes}`;

    let endMinutes = this.end_datetime.getMinutes();
    if (endMinutes < 10) {
      endMinutes = `0${endMinutes}`
    }
    const endTime = `${this.end_datetime.getHours()}:${endMinutes}`;

    return `${this.date} ${starTime} - ${endTime}`;
  }

  /**
   * Check if date is in the past
   */
  checkIsArchived() {
    let today = new Date();
    return today - this.end_datetime > 0;
  }

  async update(data) {
    let res = await ApiService.put(`/timeslot/${this.id}/`, data);
    this.isOpen = res.data.is_open;
    return res.data;
  }
}
export default TimeSlot;
